const memoryStorage = new Map()

function getBrowserLocalStorage() {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    return window.localStorage
  } catch (error) {
    return null
  }
}

function readPayload(rawValue) {
  if (!rawValue) {
    return null
  }

  try {
    const payload = JSON.parse(rawValue)
    if (!payload || typeof payload !== 'object') {
      return null
    }
    return payload
  } catch (error) {
    return null
  }
}

function writeToMemory(key, value, ttlMs) {
  const expiresAt =
    typeof ttlMs === 'number' && ttlMs > 0 ? Date.now() + ttlMs : null
  memoryStorage.set(key, { value, expiresAt })
}

function readFromMemory(key) {
  const payload = memoryStorage.get(key)
  if (!payload) {
    return null
  }

  if (payload.expiresAt && payload.expiresAt <= Date.now()) {
    memoryStorage.delete(key)
    return null
  }

  return payload.value
}

function removeFromMemory(key) {
  memoryStorage.delete(key)
}

const safeStorage = {
  get(key) {
    const storage = getBrowserLocalStorage()
    if (!storage) {
      return readFromMemory(key)
    }

    try {
      const payload = readPayload(storage.getItem(key))
      if (!payload) {
        return null
      }

      if (payload.expiresAt && payload.expiresAt <= Date.now()) {
        storage.removeItem(key)
        removeFromMemory(key)
        return null
      }

      return payload.value
    } catch (error) {
      return readFromMemory(key)
    }
  },

  set(key, value, ttlMs) {
    const expiresAt =
      typeof ttlMs === 'number' && ttlMs > 0 ? Date.now() + ttlMs : null
    const payload = JSON.stringify({ value, expiresAt })

    writeToMemory(key, value, ttlMs)

    const storage = getBrowserLocalStorage()
    if (!storage) {
      return
    }

    try {
      storage.setItem(key, payload)
    } catch (error) {
      // storage is unavailable or full; memory fallback is already set.
    }
  },

  remove(key) {
    removeFromMemory(key)

    const storage = getBrowserLocalStorage()
    if (!storage) {
      return
    }

    try {
      storage.removeItem(key)
    } catch (error) {
      // Ignore unavailable storage.
    }
  },

  clear() {
    memoryStorage.clear()

    const storage = getBrowserLocalStorage()
    if (!storage) {
      return
    }

    try {
      storage.clear()
    } catch (error) {
      // Ignore unavailable storage.
    }
  },
}

export default safeStorage
